import React, { useMemo } from 'react';
import { OauthDescribeSuccessResponse } from '../../../lib-api/services/Oauth';
import { useAppSelector } from '../../../stores/redux-store';

type ClientProviderProps = {
  children: React.ReactNode;
};

const ClientContext = React.createContext<{
  clientDescription?: OauthDescribeSuccessResponse;
} | null>(null);

export const ClientProvider = ({ children }: ClientProviderProps) => {
  const { description } = useAppSelector((state) => state.oauth);

  const contextValue = useMemo(
    () => ({
      clientDescription: description,
    }),
    [description]
  );

  return <ClientContext.Provider value={contextValue}>{children}</ClientContext.Provider>;
};

export const useClient = () => {
  const context = React.useContext(ClientContext);

  if (context === null) {
    throw new Error("useClient can't be used outside of ClientProvider");
  }

  return context;
};
